import { BrowserRouter, Routes, Route } from "react-router-dom";
import "@/App.css";

import Header from "./components/sections/Header";
import Hero from "./components/sections/Hero";
import Marquee from "./components/sections/Marquee";
import Awards from "./components/sections/Awards";
import About from "./components/sections/About";
import Services from "./components/sections/Services";
import Gallery from "./components/sections/Gallery";
import Reviews from "./components/sections/Reviews";
import Visit from "./components/sections/Visit";
import Footer from "./components/sections/Footer";
import StickyCTA from "./components/sections/StickyCTA";
import ChatWidget from "./components/ChatWidget";

const Home = () => {
  return (
    <div data-testid="home-page" className="bg-sand-50 text-ink-900 font-sans">
      <Header />
      <main>
        <Hero />
        <Marquee />
        <Awards />
        <About />
        <Services />
        <Gallery />
        <Reviews />
        <Visit />
      </main>
      <Footer />
      <StickyCTA />
      <ChatWidget />
    </div>
  );
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
